import React from "react";

export default function CopyrightPolicy() {
    return (
        <div style={{ padding: "2rem", maxWidth: 800, margin: "0 auto" }}>
            <h1>Copyright Policy</h1>
            <p>Last updated: {new Date().getFullYear()}</p>

            <p>
                MuultiSpace respects the intellectual property rights of creators.
                Users are responsible for ensuring that content uploaded to their
                MuultiSpace pages does not infringe on the rights of others.
            </p>

            <h2>1. User Responsibility</h2>
            <p>
                By uploading or publishing content, you affirm that you own the rights
                to the material or have permission from the rightful owner.
            </p>

            <h2>2. Reporting Infringement</h2>
            <p>
                If you believe that content on MuultiSpace infringes your copyright,
                please submit a report including:
            </p>
            <ul>
                <li>Your name and contact information</li>
                <li>A description of the copyrighted work</li>
                <li>
                    The URL of the MuultiSpace page where the infringing material appears
                </li>
                <li>A statement of good-faith belief in the claim</li>
            </ul>

            <p>You may contact us at: copyright@muultispace.com</p>

            <h2>3. Actions We May Take</h2>
            <ul>
                <li>
                    Remove or disable the infringing content
                </li>
                <li>
                    Notify the user who posted the content
                </li>
                <li>
                    Suspend or terminate accounts with repeat violations
                </li>
            </ul>

            <h2>4. Counter-Notifications</h2>
            <p>
                If your content was removed by mistake, you may file a counter-notice.
                We will review the claim and may restore the content if appropriate.
            </p>
        </div>
    );
}
